import {FabricObject, Canvas} from '@postermywall/fabricjs-2';

FabricObject.customProperties = ['uid', 'clickableLink', 'page', 'gitype', 'page', 'erasable', 'version', 'idOriginalOwner', 'updatingFromObject', 'previousShadowState'];

FabricObject.prototype.isLocked = function (): boolean {
  return this.lockMovementX;
};
FabricObject.prototype.getZIndex = function (): number {
  const index = this.canvas?.getObjects().indexOf(this);
  if (index === undefined || index === -1) {
    return 0;
  }

  return index;
};

FabricObject.prototype.isActive = function (): boolean {
  if (!(this.canvas instanceof Canvas)) {
    return false;
  }

  const activeObject = this.canvas?.getActiveObject();

  // eslint-disable-next-line @typescript-eslint/no-this-alias
  let item: FabricObject | undefined = this;

  while (item) {
    if (item === activeObject) {
      return true;
    }
    item = item.group;
  }

  return false;
};
